import { Menu, MenuProps } from 'antd';
import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';

const WrapperMenu = styled(Menu)`
    &.ant-menu.sider-admin-not-collapsed {
        padding-left: 5px !important;
        .ant-menu-submenu-title,
        .ant-menu-item {
            gap: 10px !important;
            padding-left: 16px !important;
            margin-left: 0 !important;
            margin-right: 0 !important;
        }
        .ant-menu-title-content {
            margin-inline-start: 0 !important;
        }

        .ant-menu-sub.ant-menu-inline .ant-menu-item {
            padding-left: 32px !important;
        }

        .ant-menu-item.ant-menu-item-only-child .ant-menu-title-content {
            margin-inline-start: 28px !important;
        }
        .ant-menu-submenu.ant-menu-submenu-inline .ant-menu-submenu-title {
            border-radius: 0 !important;
            border-top: 1px solid var(--borderColor) !important;
            border-bottom: 1px solid var(--borderColor) !important;
        }
    }
    &.sider-admin-collapsed {
        .ant-menu-title-content {
            padding-top: 3px !important;
        }
    }
    .ant-menu-item-selected {
        color: white !important;
        background-color: var(--primaryColor) !important;
    }
`;

type MenuItem = Required<MenuProps>['items'][number];

type NavbarProps = {
    collapsed: boolean;
    openKeys: string[];
    setOpenKeys: React.Dispatch<React.SetStateAction<string[]>>;
    items: MenuItem[];
    selectedMenu: string;
    onClickMenu: MenuProps['onClick'];
};

export const Navbar: React.FC<NavbarProps> = ({
    collapsed,
    openKeys,
    items,
    selectedMenu,
    onClickMenu,
    setOpenKeys,
}) => {
    return (
        <>
            <WrapperMenu
                key={'menu'}
                mode="inline"
                className={classNames({
                    'sider-admin-not-collapsed': !collapsed,
                    'sider-admin-collapsed': collapsed,
                })}
                onClick={onClickMenu}
                selectedKeys={[selectedMenu]}
                openKeys={openKeys}
                defaultActiveFirst={true}
                forceSubMenuRender={true}
                expandIcon={false}
                onOpenChange={keys => {
                    if (collapsed) {
                        setOpenKeys(keys as string[]);
                    }
                }}
                items={items}
                getPopupContainer={node => node.parentNode as HTMLElement}
            />
        </>
    );
};
